import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PslfTemplateSchema = withDefaults({
  type: 'pslf-template',
  objectExtensions: ['pslf-template'],
  fields: [
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'hasMany',
      name: 'pslfForms',
      type: 'pslf-form',
      options: {
        async: false,
        inverse: 'pslfTemplate',
      },
    },
    {
      kind: 'hasMany',
      name: 'pslfFields',
      type: 'pslf-field',
      options: {
        async: false,
        inverse: 'pslfTemplate',
      },
    },
    {
      kind: 'hasMany',
      name: 'pslfAssets',
      type: 'pslf-asset',
      options: {
        async: false,
        inverse: 'pslfTemplates',
      },
    },
  ],
});

export default PslfTemplateSchema;
